// src/utils/amountInWords.js
// Indian numbering (Lakh / Crore) amount in words - purely a display helper,
// computed live from the amount, never stored. ONE shared copy (moved from
// InvoiceDetail.js, 23 Oct 2026) used by invoices and by Payables.
// Pure -> src/utils/amountInWords.test.js.

const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

const twoDigits = (n) => {
  if (n < 20) return ONES[n];
  return TENS[Math.floor(n / 10)] + (n % 10 ? " " + ONES[n % 10] : "");
};
const threeDigits = (n) => {
  if (n < 100) return twoDigits(n);
  return ONES[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + twoDigits(n % 100) : "");
};

// Whole rupees in words, without the word "Rupees" ("" for 0).
const wholeInWords = (whole) => {
  let n = whole;
  const crore    = Math.floor(n / 10000000); n %= 10000000;
  const lakh     = Math.floor(n / 100000);   n %= 100000;
  const thousand = Math.floor(n / 1000);     n %= 1000;
  const parts = [];
  if (crore)    parts.push(threeDigits(crore) + " Crore");
  if (lakh)     parts.push(threeDigits(lakh) + " Lakh");
  if (thousand) parts.push(threeDigits(thousand) + " Thousand");
  if (n)        parts.push(threeDigits(n));
  return parts.join(" ");
};

/** Rounded to the rupee (invoices - same output as before the move). */
export function numberToWordsIndian(num) {
  const n = Math.round(Number(num) || 0);
  if (n === 0) return "Zero Rupees";
  return wholeInWords(n) + " Rupees";
}

/** Rupees and paise (payments): 3079752.6 -> "... Fifty Two Rupees and Sixty Paise". */
export function rupeesInWords(amount) {
  const totalPaise = Math.round((Number(amount) || 0) * 100);
  if (totalPaise <= 0) return "Zero Rupees";
  const rupees = Math.floor(totalPaise / 100);
  const paise  = totalPaise % 100;
  const r = rupees > 0 ? wholeInWords(rupees) + " Rupees" : "";
  const p = paise > 0 ? twoDigits(paise) + " Paise" : "";
  return r && p ? `${r} and ${p}` : (r || p);
}